var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{staticClass:"enum-filter",attrs:{"multiple":"","options":_vm.options},on:{"input":_vm.onFilterChange},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),_vm._v(" "),(_vm.value.length)?_c('feather-icon',{attrs:{"type":"trash-2"},on:{"click":_vm.clearValue}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }